import { render } from "./DefaultPostSectionNewsV2Cmp.vue?vue&type=template&id=c3744fa6"
import script from "./DefaultPostSectionNewsV2Cmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostSectionNewsV2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__